import React, { useEffect } from "react";
import { RCCAlert, RCCButton, RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import { useFieldArray } from "react-hook-form";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import { IComponentProjectsTab, IProject } from "./interface";
import ProjectItem from "./projectItem";

const AssociateProjects: React.FC<IComponentProjectsTab> = ({
	control,
	error,
	projectsDefaultValue,
	disabled = false,
	register,
	clearErrors,
	names
}) => {
	const { translate } = useTranslation();

	const { 
		fields: fieldsProjects, 
		remove: removeProjects,
		append: appendProjects
	} = useFieldArray({
		control,
		name: names.nameOfObject
	});

	const addProject = () => {
		clearErrors(names.nameOfObject);
		const project: IProject = {};
		project.key = v4();
		project.id = 0;
		project.pra002Id = undefined;
		project.peso = 1;

		appendProjects(project);
	};

	const removeProject = (index: number) => {
		clearErrors(names.nameOfObject);			
		removeProjects(index);
	};

	useEffect(() => {
		appendProjects(projectsDefaultValue.map((project) => ({
			id: project[names.nameOfID],
			pra002Id: project[names.nameOfSelectProject],
			peso: project[names.nameOfRangeSlider],
			key: v4()
		})));
	}, []);

	return (
		<RCCGrid
			container
			item
			direction="column"
			alignItems="center"
			justifyContent="center"
		>
			<RCCGrid
				container
				item
			>
				<RCCGrid
					container
					item
					justifyContent="flex-end"
				>
					<RCCTooltip
						color="purple"
						text={translate("Adicionar Projeto")}
					>
						<RCCButton
							color="purple"
							icon={{
								name: "plus"
							}}
							layout="isRounded"
							size="md"
							onClick={addProject}
							disabled={disabled}
						/>
					</RCCTooltip>
				</RCCGrid>
			</RCCGrid>
								
			<RCCGrid
				container
				item
			>
				{error[names.nameOfObject] && error[names.nameOfObject].message && (
					<Title color="red" size="xs">
						<RCCIcon
							name="infoCircle"
							color="var(--red)"
							style={{ marginRight: "8px"}}
						/>
						{error[names.nameOfObject].message}
					</Title>
				)}
				{fieldsProjects.length === 0 && (
					<RCCAlert
						color="grey"
						title={translate("Nenhum projeto adicionado")}
						description={translate("Aperte no botão acima para adicionar")}
					/>
				)}
				{fieldsProjects.map((project: any, index) => (
					<ProjectItem 
						removeProject={removeProject}
						register={register}
						clearErrors={clearErrors}
						control={control}
						project={project}
						disabled={disabled}
						error={error}
						index={index}
						names={names}
					/>
				))}
			</RCCGrid>
		
		</RCCGrid>
	);
};

export default AssociateProjects;
